import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import flatMap from 'lodash/flatMap';
import get from 'lodash/get';
import { SubmissionReport } from './SubmissionReport';
import { FETCHING_STATUS } from '../../../../constants';
import { perspectivesForSubmission as perspectives } from '../viewPerspectives';
import { loansByMonthToView } from '../../utils/loansByMonthToView';
import { generateContextFromLoansAndState } from '../../utils';

const submissionReportSelector = createSelector(
  state => ({
    report: state.reports.submissionReport,
    lenderColorConfig: get(state, 'lendersConfig.colorConfig', []),
  }),
  ({
     report: { fetchingStatus, loansByMonth, reportWindow },
     lenderColorConfig,
   }) => {
    if (fetchingStatus !== FETCHING_STATUS.SUCCESS) {
      return {
        fetchingStatus,
      };
    }
    const loans = flatMap(loansByMonth);
    const contextFromData = generateContextFromLoansAndState(loans, { lenderColorConfig });
    const context = {
      ...contextFromData,
    };
    const views = perspectives.map(perspective =>
      loansByMonthToView(
        loansByMonth,
        {
          context,
          perspective,
          displayWindow: reportWindow,
        },
      ));

    return {
      fetchingStatus,
      views,
    };
  },
);

const mapStateToProps = submissionReportSelector;

export const ConnectedSubmissionReport = connect(mapStateToProps)(SubmissionReport);
